// extracted by mini-css-extract-plugin
module.exports = {"tabBox":"tab_tabBox__3lQHY"};